module.exports = __webpack_public_path__ + "dd97bc5585a1b715b3b941b0b454ca84.svg";